
import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import ChoiceList from './Choice/List';
import ChoiceAdd from './Choice/Add';
import ChoiceDetail from './Choice/Detail';


export default class CatalogRoutes extends Component {
  render() {
    return (
      <Switch>
        <Redirect from="/catalog/driver/add" to="/driver/add" />
        <Redirect from="/catalog/driver/:id" to="/driver/:id" />
        <Redirect exact from="/catalog/driver" to="/driver" />

        <Redirect from="/catalog/tractor_unit/add" to="/tractor_unit/add" />
        <Redirect from="/catalog/tractor_unit/:id" to="/tractor_unit/:id" />
        <Redirect exact from="/catalog/tractor_unit" to="/tractor_unit" />

        <Redirect from="/catalog/semi_trailer/add" to="/semi_trailer/add" />
        <Redirect from="/catalog/semi_trailer/:id" to="/semi_trailer/:id" />
        <Redirect exact from="/catalog/semi_trailer" to="/semi_trailer" />

        <Redirect from="/catalog/point/add" to="/point/add" />
        <Redirect from="/catalog/point/:id" to="/point/:id" />
        <Redirect exact from="/catalog/point" to="/point" />

        <Redirect from="/catalog/service/add" to="/service/add" />
        <Redirect from="/catalog/service/:id" to="/service/:id" />
        <Redirect exact from="/catalog/service" to="/service" />

        <Route path="/catalog/choice" exact component={ChoiceList} />
        <Route path="/catalog/choice/add" exact component={ChoiceAdd} />
        <Route path="/catalog/choice/:id" component={ChoiceDetail} />
      </Switch>
    );
  }
}
